import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { AxiosClient } from "redux/AxiosClient";

export const uploadWordOfTheDayExcelAsync = createAsyncThunk(
  "admin/uploadWordOfTheDayExcel",
  async (payload, toolkit) => {
    return await AxiosClient(
      "POST",
      `/uploadWordOfTheDayExcel`,
      payload,
      toolkit
    );
  }
);

export const addDailyUseSentencesAsync = createAsyncThunk(
  "admin/addDailyUseSentences",
  async (payload, toolkit) => {
    return await AxiosClient("POST", `/addDailyUseSentences`, payload, toolkit);
  }
);

export const getAllDailyUseSentencesAsync = createAsyncThunk(
  "admin/getAllDailyUseSentences",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getAllDailyUseSentences?page=${payload.page || ""}&limit=${
        payload.limit || ""
      }`,
      [],
      toolkit
    );
  }
);

export const getDailyUseSentenceByIdAsync = createAsyncThunk(
  "admin/getDailyUseSentenceById",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getDailyUseSentenceById/${payload}`,
      [],
      toolkit
    );
  }
);

export const updateDailyUseSentencesByIdAsync = createAsyncThunk(
  "admin/updateDailyUseSentencesById",
  async (payload, toolkit) => {
    return await AxiosClient(
      "PUT",
      `/updateDailyUseSentencesById`,
      payload,
      toolkit
    );
  }
);

export const deleteDailyUseSentenceAsync = createAsyncThunk(
  "admin/deleteDailyUseSentence",
  async (payload, toolkit) => {
    return await AxiosClient(
      "DELETE",
      `/deleteDailyUseSentence/${payload}`,
      [],
      toolkit
    );
  }
);

export const deleteDailyUseSentenceMapAsync = createAsyncThunk(
  "admin/deleteDailyUseSentenceMap",
  async (payload, toolkit) => {
    return await AxiosClient(
      "DELETE",
      `/deleteDailyUseSentenceMap/${payload}`,
      [],
      toolkit
    );
  }
);

export const uploadDailyUseSentenceAsync = createAsyncThunk(
  "admin/uploadDailyUseSentence",
  async (payload, toolkit) => {
    return await AxiosClient(
      "POST",
      `/uploadDailyUseSentence`,
      payload,
      toolkit
    );
  }
);
